import React from 'react'
import { toJS } from 'mobx'

/* TODO: This is broken for longer periods - use carefully */
export default function DurationFromSecondsValue ({ seconds }) {
  const date = new Date(0)

  date.setSeconds(toJS(seconds) || 0)

  return (
    <div>
      {date.toISOString().substr(11, 8)}
    </div>
  )
}
